<template v-if="visible">
  <a-modal
    :title="title"
    style="top: 20px;"
    :width="800"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :form="form">
      <a-row :gutter="8">
        <a-col :md="12" :sm="24">
          <a-form-item label="剩余金额：" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <span class="ant-form-text">
              {{ lastMoney }}
            </span>
          </a-form-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="收款日期"
          >
            <a-date-picker
              :format="dateFormat"
              v-decorator="[
                  'date',
                  {initialValue:formdata.date, rules: [{ required: true, message: '请选择收款日期' }]}
                ]"
            />
          </a-form-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="收款金额"
          >
            <a-input-number
              :min="1"
              :precision="2"
              v-decorator="[
                  'money',
                  {rules: [{ required: true, message: '请输入金额' }]}
                ]"
            />
          </a-form-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-form-item
            :wrapperCol="{xs: { span: 24 },sm: { span: 24 }}"
          >
            <a-textarea
              placeholder="添加备注信息"
              :autosize="{ minRows: 2, maxRows: 6 }"
              v-model="formdata.note"
            />
          </a-form-item>
        </a-col>
      </a-row>

    </a-form>
  </a-modal>
</template>

<script>

import { addProceedsItem } from '@/api/money'
import moment from 'moment'
import ACol from 'ant-design-vue/es/grid/Col'
import { CODE_FAIL } from '@/store/mutation-types'
export default {
  name: 'ProceedsAddItem',
  components: {
    ACol
  },
  props: {
    title: {
      type: String,
      default: '收款'
    },
    mpiId: {
      type: String,
      default: ''
    },
    customerId: {
      type: String,
      default: ''
    },
    lastMoney: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    formdata: {
      type: Object,
      default: () => ({
        date: moment(),
        money: 0,
        note: ''
      })
    }
  },
  data () {
    return {
      dateFormat: 'YYYY-MM-DD',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this, this.formdata),
      customerModalvisible: false
    }
  },
  beforeCreate () {
  },
  created () {

  },
  methods: {
    handleOk () {
      const vm = this
      this.form.validateFields((err, values) => {
        if (!err) {
          const datas = Object.assign({}, this.formdata, values, { mpiId: this.mpiId, customerId: this.customerId })
          if (datas.date) {
            datas.date = moment(datas.date).format(this.dateFormat)
          }
          addProceedsItem(datas).then(res => {
            if (res.status !== CODE_FAIL) {
              this.$message.success('收款成功')
              this.form.resetFields()
              vm.$emit('handleOk', datas)
            } else {
              this.$message.error(res.message)
            }
          })
        }
        vm.$emit('formerror', err)
      })
    },
    handleCancel () {
      this.$emit('handleCancel')
    }
  }
}
</script>

<style>
  .ant-input-number {
    width: 100%;
  }
</style>
